"use client";

import type { Entry } from "contentful";
import { trackFooterNavItemClicked } from "@/lib/analytics/segment";
import type { TypeFooterNavLinksSkeleton } from "@/types/contentful/generated";
import { CmsLink } from "./CmsLink";

export type FooterNavLinkEntry = Entry<TypeFooterNavLinksSkeleton, undefined, string>;

interface Props {
  link: FooterNavLinkEntry;
}

export function FooterNavLink({ link }: Props) {
  const { label, destinationUrl, isNewTab } = link.fields;

  return (
    <li>
      <CmsLink
        destination={destinationUrl}
        isNewTab={isNewTab}
        className="text-sm font-medium leading-none no-underline!"
        onNavigate={href => trackFooterNavItemClicked({ label, destinationUrl: href })}
      >
        {label}
      </CmsLink>
    </li>
  );
}
